import { ChangeDetectionStrategy, Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AdditionalCoverageInfoModalComponent } from '../../../../../../shared/modals';
import { CoverageIdEnum, NewModal } from 'outshared-lib';
import { CoverageGroupDefault, CoverageInput } from '../../classes';
import { CoverageGroupLayoutEnum } from '../../enums';
import { TooltipModule } from '@app/shared/tooltip/tooltip.module';
import { DecimalPipe, NgIf } from '@angular/common';
import { WucIconUiModule, WucTabsetItemModule, WucTabsetModule } from '@inshared/website-ui-components';
import { PanelExpandableModule } from '@app/shared/ux/panel-expandable/panel-expandable.module';

@Component({
    selector: 'ins-coverage-disabled',
    templateUrl: 'coverage-disabled.component.html',
    styleUrls: ['./coverage-disabled.component.scss'],
    standalone: true,
    imports: [
        TooltipModule,
        FormsModule,
        NgIf,
        DecimalPipe,
        WucIconUiModule,
        WucTabsetModule,
        WucTabsetItemModule,
        PanelExpandableModule,
    ],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CoverageDisabledComponent),
        multi: true,
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoverageDisabledComponent implements ControlValueAccessor, OnInit {

    @Input() public group!: CoverageGroupDefault;

    public input: CoverageInput;
    public coverageGroupLayoutEnum: typeof CoverageGroupLayoutEnum;
    public propagateChange;
    public value: { enabled: boolean } = {
        enabled: false,
    };
    public disabled: boolean = false;
    public description: string;
    public coverageIdEnum = CoverageIdEnum;
    public modalService: NewModal = inject(NewModal);

    constructor(
        private newModal: NewModal,
    ) {
        this.coverageGroupLayoutEnum = CoverageGroupLayoutEnum;
    }

    public ngOnInit(): void {
        this.input = this.group.inputs[0];
    }

    public changeValue(): void {
        this.propagateChange();
    }

    public writeValue(value: CoverageIdEnum[]): void {
        if (value && value.length > 0) {
            this.value.enabled = true;
        } else {
            this.disabled = true;
        }
    }

    public registerOnChange(fn: any): void {
        this.propagateChange = () => {
            fn(this.value.enabled ? this.input.coverageIds : []);
        };
    }

    public registerOnTouched(): void {
        return;
    }

    public infoModalAdditionalCoverage(event: Event, input: CoverageInput): void {
        event.stopPropagation();
        event.preventDefault();
        this.newModal
            .open<AdditionalCoverageInfoModalComponent>(AdditionalCoverageInfoModalComponent, {
                data: {
                    coverage_id: input.id,
                    coverage_title: input?.data?.title,
                },
            });
    }

    public async infoModalCoverageControl(event: Event): Promise<void> {
        event.stopPropagation();
        event.preventDefault();
        const { CoverageControlInformationModal } = await import('../coverage-control-information/coverage-control-information.modal');
        this.modalService.open(CoverageControlInformationModal, { data: this.input?.data });
    }
}
